<template>
  <div class="sc-chip-select-container">
    <div
      v-for="(option, index) of optionObjects"
      :key="option.id"
      class="sc-chip-select-chip sc-chip-select-unselected-chip"
      v-bind:class="{ 'sc-chip-select-selected-chip': option.isSelected }"
      v-on:click="onClickChip(index)">
        {{ option.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScChipSelect',
  data () {
    return {
      optionObjectId: 0,
      optionsAreObjects: false,
      optionObjects: [],
      selected: []
    }
  },
  props: {
    options: {
      type: Array,
      default () {
        return []
      }
    },
    labelProp: {
      type: String
    },
    multiSelect: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.checkInput()
    this.createOptionObjects()
  },
  methods: {
    checkInput () {
      if (!this.options || this.options.length === 0) {
        throw Error('options are missig!')
      }
      if (!this.multiSelect && this.options.length > 1 && this.options[0] instanceof Object) {
        let selectedCounter = 0
        for (let i = 0; i < this.options.length; i++) {
          if (this.options[i].isSelected) {
            selectedCounter++
          }
          if (selectedCounter > 1) {
            throw Error('in single select mode only one default element allowed!')
          }
        }
      }
    },
    onClickChip (index) {
      if (this.multiSelect) {
        this.toggleChipSelect(index)
      } else {
        this.unselectChips(index)
        this.optionObjects[index].isSelected = true
        this.selected[0] = this.optionObjects[index]
      }
      this.setDataToEmit()
    },
    toggleChipSelect (index) {
      let option = this.optionObjects[index]
      option.isSelected = !option.isSelected
      if (option.isSelected) {
        this.selected.push(option)
      } else {
        this.selected.splice(this.selected.findIndex(selectedOption => selectedOption.id === option.id), 1)
      }
      this.selected.sort((a, b) => {
        return a.id > b.id ? 1 : -1
      })
    },
    unselectChips (index) {
      this.optionObjects.forEach(option => {
        option.isSelected = false
      })
    },
    checkIfOptionsAreObjects () {
      this.optionsAreObjects = this.options[0] instanceof Object
    },
    createOptionObjects () {
      this.checkIfOptionsAreObjects()
      this.options.forEach(option => {
        if (this.optionsAreObjects && this.labelProp) {
          let tempObject = JSON.parse(JSON.stringify(option))
          tempObject.id = this.optionObjectId++
          tempObject.label = option[this.labelProp]
          tempObject.originalObject = option
          this.optionObjects.push(tempObject)
          if (tempObject.isSelected) {
            this.selected.push(tempObject)
          }
        } else {
          let tempObject = { label: option, isSelected: false, id: this.optionObjectId++ }
          this.optionObjects.push(tempObject)
        }
      })
      if (!this.optionsAreObjects) {
        this.optionObjects[0].isSelected = true
        this.selected.push(this.optionObjects[0])
      }
      this.setDataToEmit()
    },
    setDataToEmit () {
      if (this.optionsAreObjects) {
        let originalObjects = []
        this.selected.forEach(option => {
          option.originalObject.isSelected = true
          originalObjects.push(option.originalObject)
        })
        this.emitSelected(originalObjects)
      } else {
        let selectedStrings = []
        this.selected.forEach(option => {
          selectedStrings.push(option.label)
        })
        this.emitSelected(selectedStrings)
      }
    },
    emitSelected (options) {
      if (this.multiSelect) {
        this.$emit('select', options)
      } else {
        this.$emit('select', options[0])
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sc-chip-select-chip {
  border-radius: $sc-chipselect-border-radius;
  display: inline-block;
  margin: $sc-chipselect-margin;
  padding: $sc-chipselect-padding;
  cursor: pointer;
  user-select: none;
}
.sc-chip-select-unselected-chip {
  background-color: $sc-chipselect-bg;
  border: 2px solid $sc-chipselect-border-color;
  color: $sc-chipselect-color;

  &:hover {
    background-color: $sc-chipselect-bg-hover;
    border: 2px solid $sc-chipselect-border-color-hover;
    color: $sc-chipselect-color-hover;
  }
}
.sc-chip-select-selected-chip {
  background-color: $sc-chipselect-bg-selected;
  color: $sc-chipselect-color-selected;
  border: 2px solid $sc-chipselect-bg-selected;

  &:hover {
    background-color: $sc-chipselect-bg-selected-hover;
    color: $sc-chipselect-color-selected-hover;
    border: 2px solid $sc-chipselect-bg-selected-hover;
  }
}
</style>
